import React from "react";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import LoadingScreen from "../LoadingScreen";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
const MakeAndModel = ({ hideNavbar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
 const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [selectedRowIndex, setselectedRowIndex] = useState(null);
  const [vehicleMake, setVehicleMake] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [makeList, setMakeList] = useState([]);
  const [modelList, setModelList] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1109`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setMakeList(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1109", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=673`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setModelList(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 673", err);
      });
  };

  function getDataFromMake(make) {
    setIsLoading(true);

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=459&MAKE=${make}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setData(res?.data);
        setTableData(res?.data)
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 459", err);
      });
  }


  
  // Adding and Removing from the Grid
  const AddToGrid = () => {
    const newValue = {
      MODEL: vehicleModel,
      MAKE: vehicleMake,
    };
    setTableData([...tableData, newValue]);
    setVehicleModel("");
  };

  const RemoveFromGrid = () => {
    if (tableData.length > 0) {
      const updatedValues = [...tableData];
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setselectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      setTableData(updatedValues);
      setVehicleModel("");
    } else {
      alert("Please add data details First");
    }
  };


   // ********************* SAVE **********************
      async function Save() {
        setIsLoading(true);
        let successCount = 0;
        let successMessage = null;
        let errorCount = 0;
        let errorMessage = null;
        const dataModels = new Set(data?.map((d) => d?.MODEL));
        const filterModelNotAdded = tableData?.filter(
          (item) => !dataModels.has(item?.MODEL),
        );
        for (let i = 0; i < filterModelNotAdded?.length; i++) {
          const value = filterModelNotAdded[i];
            try {
              const response = await axios.post(
                `${BASEURL_GLOBAL}/globalSpHandler?spname=231`,
                {
                  MODEL: value?.MODEL,
                  MAKE : value?.MAKE,
                  DATE: moment(new Date()).format("YYYY/MM/DD"),
                  PROCESSEDBY: user,
                  SUCCESS_STATUS: "",
                  ERROR_STATUS:"",
                 },
                {
                  headers: {
                    "auth-token": authToken,
                    "session-token": sessiontoken,
                  },
                },
              );
    
              if (response.status === 201) {
                successCount++;
                successMessage = response.data.message;
              } else {
                errorCount++;
                errorMessage = response.data.message;
              }
            } catch (error) {
              setIsLoading(false);
              console.error(
                `Error while Saving Vehicle Model`,
                error,
              );
              alert(error.response.data.message);
            }
        }
        setIsLoading(false);
        if (
          successCount == filterModelNotAdded?.length &&
          successMessage
        ) {
          alert("Vehicle Model is Linked to Make Successfully");
          window.location.reload();
        }
        if (errorMessage) {
          alert(errorMessage);
        }
      }

  if (isLoading) {
    return <LoadingScreen />;
  }
  return (
    <div className="min-h-100vh">
      {!hideNavbar && <AllPagesNavbar />}
      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">
          {"VEHICLE MAKE TO MODEL"}
        </h1>
      </header>

      <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
        <IoDocumentOutline
          size={24}
           onClick={() => {
            setVehicleMake("");
            setVehicleModel("");
            setData([]);
            setTableData([]);
          }}
          className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
        />
        <FaSave
          size={24}
          onClick={async () => {
            await Save();
          }}
          className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
        />
        <GiCrossMark
          size={24}
          className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
        />
        <IoPrintSharp
          size={24}
          className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
        />
      </div>

      <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
        <div className="flex">
          <p className="text-red-600 mr-2">Make :</p>
          <Select
            className="w-64"
            value={
              vehicleMake
                ? { value: vehicleMake, label: vehicleMake }
                : { value: "", label: "Select Make" }
            }
            onChange={(e) => {
              if (e.value !== "") {
                setVehicleMake(e.value);
                getDataFromMake(e.value);
              } else {
                setVehicleMake(e.value);
              }
            }}
            options={[
              { value: "", label: "Select Make" },
              ...makeList?.map((item) => ({
                value: item?.MAKE,
                label: item?.MAKE,
              })),
            ]}
          ></Select>
        </div>
      </div>

      <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-auto border border-gray-300 text-sm">
          <thead class="sticky top-0 w-44">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">S NO</td>
              <td className="py-2 px-4 border border-gray-300 text-left">VEHICLE MODEL</td>
            </tr>
          </thead>
          <tbody>
            {" "}
            {tableData.map((row, index) => (
              <tr
                className="hover:bg-gray-100 cursor-pointer text-[12px]"
                key={index}
                onClick={() => {
                  setVehicleMake(row?.MAKE);
                  setVehicleModel(row?.MODEL);
                    setselectedRowIndex(index);
                }}
              >
                <td className="py-2 px-4 text-right border border-gray-300 w-20">{index + 1}</td>
                <td className="py-2 px-4 text-left border border-gray-300 w-40">{row.MODEL ? row.MODEL : "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </aside>

      <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
        <div className="flex">
          <p className="text-red-600 mr-2">Model :</p>
          <Select
            className="w-64"
            value={
              vehicleModel
                ? { value: vehicleModel, label: vehicleModel }
                : { value: "", label: "Select Model" }
            }
            onChange={(e) => setVehicleModel(e.value)}
            options={[
              { value: "", label: "Select Model" },
              ...modelList?.map((item) => ({
                value: item?.MODEL,
                label: item?.MODEL,
              })),
            ]}
          ></Select>
        </div>
        <div className="flex gap-2">
          <button className="flex h-7 lg:mt-3 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
              if (!vehicleModel) {
                alert("Kindly Supply Model");
                return;
              } else {
                const model = data?.find((item) => item?.MODEL === vehicleModel);
                if (model) {
                  alert("This Model is available");
                  return;
                } else {
                  AddToGrid();
                }
              }
            }}
          >
            Add
          </button>
          <button className=" flex h-7 lg:mt-3 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
              if (selectedRowIndex !== null) {
                const modelLinked = data?.find(
                  (item) => item?.MODEL === vehicleModel,
                );
                if (modelLinked) {
                  alert("This Model is Linked to Make");
                  return;
                } else {
                  RemoveFromGrid();
                }
              } else {
                RemoveFromGrid();
              }
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default MakeAndModel;
